export const SERVICE_MARKETPLACE_LIST_REQUEST =
  "SERVICE_MARKETPLACE_LIST_REQUEST";
export const SERVICE_MARKETPLACE_LIST_SUCCESS =
  "SERVICE_MARKETPLACE_LIST_SUCCESS";
export const SERVICE_MARKETPLACE_LIST_ERROR = "SERVICE_MARKETPLACE_LIST_ERROR";
